import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Trophy, ChevronRight, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../ui/table';

function RankMedal({ index }) {
    if (index === 0) return <span className="text-xl">🥇</span>;
    if (index === 1) return <span className="text-xl">🥈</span>;
    if (index === 2) return <span className="text-xl">🥉</span>;
    return <span className="text-slate-500">{index + 1}</span>;
}

export function VPRankings({ rankings, onUserClick, onViewAll }) {
    const navigate = useNavigate();
    
    if (!rankings || rankings.length === 0) return null;
    
    const handleRowClick = (vp) => {
        if (onUserClick) {
            onUserClick(vp.id);
        }
    };
    
    const handleViewProspects = (vpId, e) => {
        e.stopPropagation();
        navigate(`/prospects?responsable=${vpId}`);
    };
    
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                    <Trophy className="w-5 h-5 text-amber-500" />
                    Top VP par Restant
                </CardTitle>
                {onViewAll && (
                    <Button variant="ghost" size="sm" onClick={onViewAll} className="gap-1">
                        Voir tout <ChevronRight className="w-4 h-4" />
                    </Button>
                )}
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className="w-12">#</TableHead>
                            <TableHead>VP</TableHead>
                            <TableHead className="text-center">Équipe</TableHead>
                            <TableHead className="text-center">Dossiers</TableHead>
                            <TableHead className="text-right">Gains Total</TableHead>
                            <TableHead className="w-20"></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {rankings.map((vp, index) => (
                            <TableRow 
                                key={vp.id}
                                className="cursor-pointer hover:bg-slate-50 transition-colors"
                                onClick={() => handleRowClick(vp)}
                            >
                                <TableCell><RankMedal index={index} /></TableCell>
                                <TableCell className="font-medium">
                                    <span className="hover:text-blue-600 hover:underline">
                                        {vp.name}
                                    </span>
                                </TableCell>
                                <TableCell className="text-center">
                                    <Badge variant="outline">{vp.teamSize} apporteurs</Badge>
                                </TableCell>
                                <TableCell className="text-center">
                                    <span className="font-medium">{vp.dossiers}</span>
                                </TableCell>
                                <TableCell className="text-right font-bold text-green-600">
                                    {vp.totalGain.toLocaleString('fr-FR')} €
                                </TableCell>
                                <TableCell>
                                    <Button 
                                        variant="ghost" 
                                        size="sm" 
                                        onClick={(e) => handleViewProspects(vp.id, e)}
                                        title="Voir les dossiers"
                                    >
                                        <Eye className="w-4 h-4" />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}

export function ApporteurRankings({ rankings, onUserClick, onViewAll }) {
    const navigate = useNavigate();
    
    if (!rankings || rankings.length === 0) return null;
    
    const handleRowClick = (ap) => {
        if (onUserClick) {
            onUserClick(ap.id);
        }
    };
    
    const handleViewProspects = (apId, e) => {
        e.stopPropagation();
        navigate(`/prospects?responsable=${apId}`);
    };
    
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                    <Trophy className="w-5 h-5 text-amber-500" />
                    Top Apporteurs par Restant
                </CardTitle>
                {onViewAll && (
                    <Button variant="ghost" size="sm" onClick={onViewAll} className="gap-1">
                        Voir tout <ChevronRight className="w-4 h-4" />
                    </Button>
                )}
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className="w-12">#</TableHead>
                            <TableHead>Apporteur</TableHead>
                            <TableHead className="text-center">Dossiers gagnés</TableHead>
                            <TableHead className="text-right">Gains Total</TableHead>
                            <TableHead className="w-20"></TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {rankings.map((ap, index) => (
                            <TableRow 
                                key={ap.id}
                                className="cursor-pointer hover:bg-slate-50 transition-colors"
                                onClick={() => handleRowClick(ap)}
                            >
                                <TableCell><RankMedal index={index} /></TableCell>
                                <TableCell className="font-medium">
                                    <span className="hover:text-blue-600 hover:underline">
                                        {ap.name}
                                    </span>
                                </TableCell>
                                <TableCell className="text-center">
                                    <span className="font-medium">{ap.dossiers}</span>
                                </TableCell>
                                <TableCell className="text-right font-bold text-green-600">
                                    {ap.totalGain.toLocaleString('fr-FR')} €
                                </TableCell>
                                <TableCell>
                                    <Button 
                                        variant="ghost" 
                                        size="sm" 
                                        onClick={(e) => handleViewProspects(ap.id, e)}
                                        title="Voir les dossiers"
                                    >
                                        <Eye className="w-4 h-4" />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
